import ZeroDataButtonExample from "./examples/ZeroData.Button.Example";
import barsImage from './examples/bars.png';

export default [
    {
        title: "Basic zero data",
        component: ZeroDataButtonExample,
        code: require("!raw-loader!./examples/ZeroData.Button.Example.tsx"),
        dependencies: {
            "bars.png": barsImage
        }
    }
];
